import gsap from 'gsap'

import type { RefObject } from 'react'

import { useEffect } from 'react'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Fades and lifts every [data-reveal] element inside `ref` as it scrolls into view.
export const useReveal = (ref: RefObject<HTMLElement | null>, key: unknown = null) => {
    useEffect(() => {
        const root = ref.current

        if (!root) return
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

        gsap.registerPlugin(ScrollTrigger)

        const context = gsap.context(() => {
            const items = Array.from(root.querySelectorAll<HTMLElement>('[data-reveal]'))

            if (!items.length) return

            gsap.set(items, { autoAlpha: 0, y: 36 })

            ScrollTrigger.batch(items, {
                start: 'top 90%',
                once: true,
                onEnter: batch => {
                    // clearProps hands control back to CSS afterwards, so hover transforms keep working.
                    gsap.to(batch, { autoAlpha: 1, y: 0, duration: 0.95, ease: 'power3.out', stagger: 0.09, overwrite: true, clearProps: 'transform,opacity,visibility' })
                }
            })
        }, root)

        return () => context.revert()
    }, [ref, key])
}
